import { connect } from "react-redux";
import { getCommunications, getSession } from "../selectors";
import LoginForm from "../components/login-form";
import pure from "../components/higher-order/pure";
import React from "react";
import { sessionLogin } from "../actions/session";
import SignupLink from "../components/signup-link";

function UnauthorizedPage({ communications, sessionLogin: onSessionLogin }) {
  var errorMessage = communications.getIn(["sessionLogin", "error", "error"]);
  var loading = communications.getIn(["sessionLogin", "state"]) === "in progress";

  return (
    <div className="l-main l-row">
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">
          <div>
            <h1 className="text-center">
              Log in to your account.
            </h1>

            <div className="batch-g batch-g--padding">
              <div className="batch-c-1-1 batch-c-md-2-3">
                <LoginForm errorMessage={errorMessage} loading={loading} onLogin={onSessionLogin} />
              </div>

              <div className="batch-c-1-1 batch-c-md-1-3">
                <Media heading="Play for MONEY" icon="dw-dollars">
                  Enter money games for as little as $1 or higher stakes games for more.
                </Media>

                <Media heading="Play for FREE" icon="dw-points">
                  Create your FREE account &amp; get 1,000 player points. Use your points to enter free games &amp; get started!
                </Media>

                <hr />

                <p>
                  Don&apos;t have an account?
                </p>

                <SignupLink className="btn btn--small">
                  Create FREE Account Now
                </SignupLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Media({ children, heading, icon }) {
  return (
    <div className="media media--small hidden--mobile">
      <div className="media_graphic">
        <i className={icon} />
      </div>

      <div className="media_body">
        <h2 className="media_heading">
          {heading}
        </h2>

        <p className="media_text">
          {children}
        </p>
      </div>
    </div>
  );
}

function select(state, props) {
  return {
    communications: getCommunications(state, props),
    session: getSession(state, props)
  };
}

export default connect(select, { sessionLogin })(pure(UnauthorizedPage));
